
const isLocal = window.location.hostname === "localhost";
export const isLiferay = window.location.hostname === "dubaihealth.ae";
const basePath = isLocal ? "" :
    (isLiferay ? "/eservices"
        : "/portalservices/eservices");

export const config = {
    agentOauthAppId: "liferay-dha-backend-etc-node-oauth-application-user-agent",

    backendBaseAddress: isLocal
        ? "https://localhost:7161"
        : (isLiferay ?
            "https://dubaihealth.ae"
            : "https://services.dubaihealth.ae"),

    patientServices: `${basePath}/patient/`,
    sickleaveServices: `${basePath}/sickleave/`,
    escortLeaveServices: `${basePath}/escort-leave/`,
    paymentReconcilliationServices: `${basePath}/payment-reconcilliation/`,
    refundPayment: `${basePath}/refundPayment/`,
    manualMatchingServices: `${basePath}/manual-matching/`,
    paymentServices: `${basePath}/payment/`,
    coveerageServices: `${basePath}/coverage/`,
    epicAuthEndPoint: `${basePath}/auth/token`,
    otherDashboardServices: `${basePath}/other-dashboard-service/`,
    medicalReportServices: `${basePath}/medical/`,
    renewHealthService: `${basePath}/renewhealth/`,
    medicalFitnessService: `${basePath}/medicalFitness/`,
    manageDependents: `${basePath}/manage-dependents/`,
    viewMrn: `${basePath}/view-mrn/`,
    bloodDonationServices: `${basePath}/bloodDonation/`,
    smartregistration: `${basePath}/smart-registration`,
    renewHealthLiferayService: `${basePath}/liferay/renewHealth/`,
    common: `${basePath}/liferay/`,
    liferayBaseAddress: isLocal
        ? "http://localhost:7161"
        : "https://dubaihealth.ae",
    slaBackUrl: `${basePath}/c/sickleave-service`,
    mrBackUrl: `${basePath}/c/medical-report-service`,
    hcrBackUrl: `${basePath}/c/health-card-info`,
    dbdBackUrl: isLiferay ? `/blood-donation` : `${basePath}/c/dammi-blood-donation`,
    slaServiceName: "Service Details",
    mrServiceName: "Medical Report",
    hcrServiceName: "Coverage Plan",
    translationUrl: `${basePath}/liferay/translate/`,
    myChartBaseUrl: "https://services.dubaihealth.ae/MyChart/Extensibility/Redirection/Content?fdi=",
    mobileBaseUrl: "dubaihealthmychart://fdiredirect?webid=",
    slaWebMyChatFdi: "WP-24UBNOC3pBpy7yUWRFP4hP1A-3D-3D-24pXQ3i-2BO5aUmnP-2FcbX38w0F9Zz9GWVy-2Ff1KG57VHSOiI-3D",
    mrWebMyChatFdi: "WP-24VgOJw7-2B-2BArRpogrRd6z0xw-3D-3D-24V1ZMpdIdPEfMtzUSu8piG5mjr6k9Jjwyt6AioDKtDZE-3D",
    hciWebMyChartFdi: "WP-24hjZ6huLZ8AzMzJV3kDdODQ-3D-3D-24YC7-2BCoQgI2LBalV58x7zpytYXJtmK0SQSMmg5uDovgI-3D",
    slaMobileMyChatFdi: "WP-24-2BpeMVe-2Bui2h3NeM-2B1lJrkA-3D-3D-24HK3OdM5HooUh7NHv8iTwSkSAeGqetdKa64SykX9icsI-3D",
    mrMobileMyChatFdi: "WP-24e02T5y-2Fmw4se3B9tmobw4A-3D-3D-24m8RmpEoVfCRKsvxnIJmczLGYXVez-2FcSNx8QMkngEGXo-3D",
    hciMobileMyChatFdi: "WP-24GGjOToYs2BUdowfATZ9THg-3D-3D-24Tt8YFAp-2BSydqrjqADIaKF4g-2FgIrJf9fnvlKwfxjT9n8-3D",
    assestsBase: `${basePath}/static/css/images/`,
    proceedToPatientUrl: "https://services.dubaihealth.ae/MyChart/Home/?lang=en-AE",
	proceedToPatientUrlArabic: "https://services.dubaihealth.ae/MyChart/Home/?lang=en-AR",
    LFR_MYCHART_ATD: "LFR_MYCHART_ATD",
    baraemServices: `${basePath}/baraemServices/`,
    idamClientId: "10312740",
    uaeCountryCode: "+971",
    happinessMeter: `${basePath}/happinessMeter`,
	bloodDonationLoginUrl: 'https://services.dubaihealth.ae/eservices/DHAWeb/RedirectPage/RedirectMain.aspx',
	baraemServiceUrl: "/group/dubai-health/baraem"

};

export const RenewHealthStatus = {
    active: {
        name: "Active",
        iconColor: "active",
    },
    expired: {
        name: "Expired",
        iconColor: "orange",
    },
    expiringSoon: {
        name: "Expiring Soon",
        iconColor: "yellow",
    },
};
export const SlamaRequestTypes = {
    sickLeaveApplication: "SLA", // Sick Leave Application
    doctorForEveryPatient: "DFC", // Doctor for Every Patient
    cordBloodSystem: "CBS", // Cord Blood System
    preMaritalScreening: "PMR", // PreMarital Screening
    medicalReportRequest: "MR", // Medical Report Request
    healthCardRenewal: "NPS", // Health Card Renewal
    healthCardIssuance: "HCI", // Health Card Issuance
};

export const ServicesAmount = {
    sickLeave: "70",
    renewHealth: "80",
    medicalReport: "270",
};

export const ServiceTranslation = {
    EscortLeave: "ela",
    SickLeave: "sla",
    OtherServiceDashboard: "osd",
    ManageDependents: "mds",
    MedicalFitness: "mfc",
    BloodDonation: "dbd",
    FindMRN: "findMrn",
    HealthCardInfo: "hci",
    MedicalReport: "mrs",
    ViewHealthCard: "vhc",
    Payment: "pay",
    Baraem: "bar",
    smartRegistration: "smr",
    PaymentReconciliation: "prc",
    PaymentRefund: "prf"
};

export const BloodDonationWebContent = {
    webStructurePKProcess: "55551",
    webStructurePKProcess_ar: "6171595", //
    templateIdProcess: "53759",
    webStructurePKCenter: "55735",
    webStructurePKCenter_ar: "6171563", //
    templateIdCenter: "55728",
    webStructurePKWhereToDonate: "116871",
    webStructurePKWhereToDonate_ar: "6171552",
    templateIdWhereToDonate: "117021",
    webStructurePKPDF: "123540",
    webStructurePKPDF_ar: "7009526", //
    templateIdPDF: "123487"
}

export const BaraemWebContent = {
    webStructurePKProcess: "204185",
    templateId: "DH_BARAEM_QUESTIONS"
}

export const BloodDonationConstants = {
    CONTENT_NOT_FOUND: "content not found",
    LOADING_CONTENT: "Loading content...",
    LOGGED_IN: "LoggedIn",
    NOT_lOGGED_IN: "NotLoggedIn",
    NOT_LIFERAY: "NotLiferay",
}

export const hostName = {
    HOSTNAME: isLocal
        ? "http://localhost:8080"
        : (isLiferay ?
                ""
                : "https://dubaihealth.ae"

        )
}

export const initialStateBloodDonation = {
    generalQuestions: [],
    past6MonthsHaveYou: [],
    travelQuestionsHaveYou: [],
    generalQuestionsHaveYou: [],
    haveYouEver: [],
    healthQuestionsHaveYou: [],
    healthQuestionsPast6Months: [],
    past6MonthsSexualContact: [],
    past6MonthsHaveYouEver: []
};

export const MedicalReportStatus = {
    failed: "FAILED",
    processed: "PROCESSED",
    rejected: "REJECTED",
    completed: "COMPLETED",
    initiated: "INITIATED",
     refunded: "REFUNDED",
    reasonEn : "A technical error occurred. Our technical team has been notified and will resolve it shortly. Thank you for your patience.",
    reasonAr : "حدث خلل تقني، الفريق التقني يعمل لمعالجته في أسرع وقت، شكراً لتفهمكم الأمر"
};
export const LiferayPages = {
  otherServicesDashboardURL: "/other-dashboard-service"
};